export default __webpack_public_path__ + "static/media/play-button.bc41ee16.svg";